import { render, staticRenderFns } from "./GutterQuestion.vue?vue&type=template&id=28db4d2b&scoped=true"
import script from "./GutterQuestion.vue?vue&type=script&lang=ts"
export * from "./GutterQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GutterQuestion.vue?vue&type=style&index=0&id=28db4d2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db4d2b",
  null
  
)

export default component.exports